import React from "react";
import { withTranslation } from "react-i18next";

const Footer = (props) => {
  return (
    <footer style={{borderTop: '1px solid #A9A9A9'}}>
	<div className="text-center py-3">
        Citing CompCorona: " <a target="_blank" href="https://journals.tubitak.gov.tr/cgi/viewcontent.cgi?article=2673&context=biology" style={{color: '#4169E1', textDecoration: 'none'}}> Salihoğlu R,Saraçoğlu F, Sibai M, Zengin T; Abak Masud B;Karasoy O,Önal-Süzek T,Turkish Journal of Biology (2023),doi:10.55730/1300-0152.2673</a>
      </div>
      <div className="text-center pt-1 pb-3">
  © 2023  | <a href="mailto:tugbasuzek@mu.edu.tr" style={{color: '#4169E1', textDecoration: 'none'}}>{props.t("Email us: tugbasuzek@mu.edu.tr ")}</a>
      </div>
    </footer>
  );
};

export default withTranslation()(Footer);
